import ssrsParams from './ssrsParams';

const $catSelect = $('#Categories');
const $reportSelect = $('#ReportList');
const $paramTopic = $('#parameters');
const $paramPane = $('#paramPane');
const $landing = $('#landing');

let k_reportSelect;
let k_catSelect;

export default function () {
    if ($reportSelect.length) k_reportSelect = $reportSelect.data('kendoDropDownList');
    if ($catSelect.length) k_catSelect = $catSelect.data('kendoDropDownList');
    updateReportList();
    setDataSourceData();
    attachFavoritesEvents();
    if ($('#paramPane:visible').length || $('#viewReport').length) {
        ssrsParams();
    }


//Open report if coming from a url option
    let params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });

    if (params && params.reportFile) {
        const favs = $('[data-action=open]');
        if (favs.length) {
            $.each(favs, function (i, e) {
                if ($(e).data('value').indexOf(params.reportFile) !== -1) {
                    $(e).click();
                }
            })
        }
    }
}

const updateReportList = () => {
    if ($catSelect.length) {
        $catSelect.change(function () {
            return new Promise((resolve, reject) => {
                if (k_reportSelect) {
                    k_reportSelect.value(0);
                    k_reportSelect.dataSource.read().then(() => {
                        resolve();
                    });
                    $reportSelect.change();
                    k_reportSelect.enable($catSelect.val() !== '0');
                    $landing.show();
                }
            });
        });
    }
};

const setDataSourceData = () => {
    let kendoOptions = k_reportSelect.dataSource.transport.options;

    if (kendoOptions.read) {
        kendoOptions.read.data = function (data) {
            data.category = k_catSelect.value();
            return data;
        };
    }

    $reportSelect.change(function () {

        let reportFile = this.value;
        let $reportTitle = $('.topbar__content .tag');

        $('#viewReport').hide();
        if (reportFile !== '0') $(document).trigger('ssrs:ReportSelected');
        if ($paramPane.length) {
            let $addFavoritesBtn = $('.ssrs__btn-favorites'), $addBtn = $addFavoritesBtn.has('.k-i-star-outline'),
                $removeBtn = $addFavoritesBtn.has('.k-i-star');
            if (reportFile === '0') {
                $addBtn.hide();
                $removeBtn.hide();
                $reportTitle.removeClass('tag--green').text('No Report Selected');
                $paramTopic.hide();
                $paramPane.html('');
                $landing.show();
                return;
            }

            let fav = $(`.ssrs__favlist-report button[data-value*='${reportFile}']`);
            if (!fav.length) {
                $addBtn.show();
                $removeBtn.hide();
            }

            if (fav.length) {
                $addBtn.hide();
                $removeBtn.show();
            }

            $reportTitle.addClass('tag--green').text(k_reportSelect.text());

            $paramPane.load(`/Reporting/Ssrs/ParamPane?reportName=${encodeURI(k_reportSelect.value())}`, function () {
                $paramTopic.show();
                // 1 Needed for Form Item Indicators
                $(document).trigger('on:PageUpdate'); // 1
                $landing.hide();
                ssrsParams();
            });
        }
    });
};

const attachFavoritesEvents = () => {
    let $favoritesBtn = $('.ssrs__favlist-report button'), $addFavoritesBtn = $('.ssrs__btn-favorites');

    if ($favoritesBtn.length) {
        $favoritesBtn.unbind('click');
        $favoritesBtn.click(function () {
            let action = $(this).attr('data-action');
            if (action === 'open') {
                let values = $(this).attr('data-value').split('/');
                k_catSelect.value(values[0]);
                k_reportSelect.dataSource.read().then(() => {
                    k_reportSelect.enable();
                    k_reportSelect.value(values[1]);
                    $reportSelect.change();
                });
            }
            if (action === 'remove') {
                let report = $(this).attr('data-value');
                updateFavsList(action, report);
            }
        });
    }

    if ($addFavoritesBtn.length) {
        $addFavoritesBtn.unbind('click');
        $addFavoritesBtn.click(function () {
            let action = $(this).attr('data-action');
            let reportName = k_reportSelect.value();

            if (reportName !== '0') {

                let fav = $(`.ssrs__favlist-report button[data-value*='${reportName}']`);
                if (action === 'add' && !fav.length || fav.length && action === 'remove') {
                    updateFavsList(action, k_reportSelect.value());
                }
            }
        });
    }
};

const updateFavsList = (action, report) => {
    return new Promise((resolve, reject) => {
        let $favsList = $('.ssrs__favlist-categroy');
        $favsList.load('/Reporting/Ssrs/UpdateFavorites', {action: action, reportName: report}, function () {
            attachFavoritesEvents();
            if (report === k_reportSelect.value()) {
                let $addFavoritesBtn = $('.ssrs__btn-favorites'), $addBtn = $addFavoritesBtn.has('.k-i-star-outline'),
                    $removeBtn = $addFavoritesBtn.has('.k-i-star');
                if (action === 'add') {
                    $addBtn.hide();
                    $removeBtn.show();
                }

                if (action === 'remove') {
                    $addBtn.show();
                    $removeBtn.hide();
                }
            }
            resolve();
        });
    });
};